import { render, staticRenderFns } from "./GarageDoorIsFunctional.vue?vue&type=template&id=87d80ca2&scoped=true"
import script from "./GarageDoorIsFunctional.vue?vue&type=script&lang=ts"
export * from "./GarageDoorIsFunctional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d80ca2",
  null
  
)

export default component.exports